"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ModalSections_1 = __importDefault(require("../../constants/ModalSections"));
var usePriceTerms_1 = require("../../hooks/usePriceTerms");
var GreyCheckMarkIcon_1 = __importDefault(require("../../icons/GreyCheckMarkIcon"));
var InfoIcon_1 = __importDefault(require("../../icons/InfoIcon"));
var formatAndDropDecimal_1 = __importDefault(require("../formatAndDropDecimal"));
var TileDataContext_1 = require("../TileDataContext");
function Terms() {
    var _a = (0, TileDataContext_1.useTileDataContext)(), vehicleId = _a.tileData.vehicleId, _b = _a.financeInfo, showFinanceInfo = _b.showFinanceInfo, tradeInApplied = _b.tradeInApplied, hasSoftPull = _b.hasSoftPull, openModal = _a.utils.openModal;
    var _c = (0, usePriceTerms_1.usePriceTerms)(), _d = _c.monthlyPayment, monthlyPayment = _d === void 0 ? 0 : _d, _e = _c.totalCashDue, totalCashDue = _e === void 0 ? 0 : _e, hasTerms = _c.hasTerms;
    var hidden = !showFinanceInfo;
    var hasValidMonthlyPayment = monthlyPayment > 0;
    return (react_1.default.createElement("div", { "data-qa": "base-terms", className: (0, classnames_1.default)('flex flex-col items-end justify-end text-sm text-grey-5', {
            hidden: hidden
        }) },
        hasTerms ? (react_1.default.createElement(react_1.default.Fragment, null,
            tradeInApplied && (react_1.default.createElement("div", { className: "flex items-center gap-4" },
                react_1.default.createElement(GreyCheckMarkIcon_1.default, null),
                " Trade applied")),
            react_1.default.createElement("div", { "data-qa": "monthly-payment", className: (0, classnames_1.default)('flex gap-4', {
                    empty: !hasValidMonthlyPayment
                }) },
                react_1.default.createElement("div", null, !hasSoftPull && 'Estimated '),
                "$",
                monthlyPayment,
                "/mo"))) : null,
        react_1.default.createElement("div", { className: "flex gap-4" },
            react_1.default.createElement("div", { "data-down-payment": totalCashDue, className: totalCashDue === 0 && hasSoftPull ? 'font-bold text-green-2' : '', "data-qa": "down-payment" },
                "$",
                (0, formatAndDropDecimal_1.default)(totalCashDue),
                " cash down"),
            react_1.default.createElement(merch_components_1.Clickable, { "data-analytics-id": null, onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openModal({
                        openTo: ModalSections_1.default.PriceDetails,
                        vehicleId: vehicleId
                    });
                }, className: "flex self-center", element: "span" },
                react_1.default.createElement(InfoIcon_1.default, null)))));
}
exports.default = Terms;
//# sourceMappingURL=Terms.js.map